<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4095"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4099"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4109"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4107" /></clipPath></defs><g
     id="g4101"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4103"><g
         id="g4105"
         clip-path="url(#clipPath4109)"><g
           id="g4111"
           transform="translate(202.8301,383.0996)"><path
             d="m 0,0 h -20.72 c -93.56,0 -170.11,-76.609 -170.11,-170.189 v -7.38 c 0,-51.79 23.41,-98.33 60.21,-129.62 0.38,-0.321 0.23,-0.401 0.15,-0.97 l 0.48,-63.5 c -0.2,-3.691 1.55,-4.721 5.21,-3.37 l 63.65,25.759 c 3.23,1.661 2.83,1.52 6.47,1.52 h 33.94 71.89 c 84.35,0 154.87,62.221 167.95,143.051"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4113" /></g><g
           id="g4115"
           transform="translate(235.8799,383.0996)"><path
             d="m 0,0 h 18.12 c 26.32,0 51.3,-6.06 73.6,-16.859"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4117" /></g><g
           id="g4119"
           transform="translate(412.0273,482.2002)"><path
             d="M 0,0 V 22.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4121" /></g><g
           id="g4123"
           transform="translate(324.0547,478.1357)"><path
             d="M 0,0 15.769,-15.773"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4125" /></g><g
           id="g4127"
           transform="translate(500,478.1357)"><path
             d="M 0,0 -15.769,-15.773"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4129" /></g><g
           id="g4131"
           transform="translate(411.9697,251.6738)"><path
             d="M 0,0 V 56.479"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4133" /></g><g
           id="g4135"
           transform="translate(374.7373,251.6738)"><path
             d="m 0,0 h 74.465 c 3.32,0 6.039,-2.72 6.039,-6.04 v -23.731 c 0,-3.321 -2.719,-6.041 -6.039,-6.041 H 0 c -3.319,0 -6.038,2.72 -6.038,6.041 V -6.04 C -6.038,-2.72 -3.319,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4137" /></g><g
           id="g4139"
           transform="translate(384.4395,215.8623)"><path
             d="m 0,0 h 55.062 v -18.75 c 0,-10.306 -8.443,-18.75 -18.746,-18.75 H 18.745 C 8.442,-37.5 0,-29.056 0,-18.75 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4141" /></g><g
           id="g4143"
           transform="translate(411.9697,357.1328)"><path
             d="m 0,0 c 12.621,0 22.838,-10.22 22.838,-22.844 0,-12.624 -10.217,-22.844 -22.838,-22.844 -12.62,0 -22.837,10.22 -22.837,22.844 C -22.837,-10.22 -12.62,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4145" /></g><g
           id="g4147"
           transform="translate(125.5,208.9062)"><path
             d="M 0,0 H 185.676"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4149" /></g><g
           id="g4151"
           transform="translate(125.5,259.832)"><path
             d="M 0,0 H 138.628"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4153" /></g><g
           id="g4155"
           transform="translate(125.5,158.0088)"><path
             d="M 0,0 H 185.676"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4157" /></g><g
           id="g4159"
           transform="translate(380.4609,438.1162)"><path
             d="m 0,0 c -29.448,-9.991 -52.915,-35.239 -52.943,-75.889 -0.058,-54.675 46.991,-63.378 51.083,-110.553 m 66.738,0 c 4.121,47.175 51.17,55.878 51.112,110.553 -0.056,53.045 -40.008,79.868 -81.047,80.727"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4161" /></g></g></g></g></svg>
</template>
